import React, { useState, useEffect, useRef } from "react";
import {
  VStack,
  HStack,
  Pressable,
  Text,
  Button,
  Box,
  CloseIcon,
} from "native-base";
import { setusersLang } from "../../../Redux/Actions/userActions";
import { Dimensions } from "react-native";
import { PageLoader } from "../../../components/loaders";
import { useLocation, useParams } from "react-router-dom";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import * as AV from "../../../AVCore/AVCore";
import { Loc } from "../../../App/Loc";
import { DollarCoinsIcon } from "../../../assets/icons/icon-assets";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import inform from "../../../assets/images/inform.png";
import PurchaseCreditsPopup from "../../../components/common/PurchaseCreditsPopup";

interface Props {
  entity?: AV.IAVEntity;
  sharedPlan?: AV.ISharedPlan;
  setSharedPlan?: (sharedPlan: AV.ISharedPlan) => void;
  isAutoTrans?: boolean;
  triggerBuyCredits?: boolean;
  setTriggerBuyCredits?: (val: boolean) => void;
}

function AutoTranslation({
  entity,
  sharedPlan,
  setSharedPlan,
  isAutoTrans,
  triggerBuyCredits,
  setTriggerBuyCredits,
}) {
  const dispatch = useDispatch();
  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  );
  const userLang = useSelector(
    (state: RootStateOrAny) => state?.user?.userLang[0],
  );
  const [pageLoader, setPageLoader] = useState(false);
  const [isEntity, setIsEntity] = useState<AV.IAVEntity | null>(null);
  const [isLoadingAdd, setIsLoadingAdd] = React.useState(false);
  const [translationLang, setTranslationLang] = useState<string>(
    Loc.currentLang.purchaseCredits.selectLanguage,
  );
  const [creditsAvailable, setCreditsAvailable] = useState<number>(
    entity ? (entity?.plan?.credits ?? 0) : (currentUser?.plan?.credits ?? 0),
  );
  const [showCreditsPopup, setShowCreditsPopup] = useState(false);
  const [isSelectedLang, setIsSelectedLang] = useState(false);
  const [modifiedUserLang, setModifiedUserLang] = useState<
    Array<{ code: string; name: string }>
  >([{ code: "", name: "" }]);
  const [selectedTranslationLang, setSelectedTranslationLang] = useState<
    Array<{ code: string; name: string }>
  >([{ code: "", name: "" }]);

  const handleLanguageUpdate = async (
    action: "add" | "remove",
    langCode?: string,
  ) => {
    if (action === "add" && !translationLang) return;

    setIsLoadingAdd(action === "add" ? true : false);
    let updatedLangCodes = selectedTranslationLang.map((lang) => lang.code);

    if (action === "add") {
      // Add new language (if it's not already in the list)
      if (!updatedLangCodes.includes(translationLang)) {
        updatedLangCodes = [translationLang, ...updatedLangCodes];
      }
    } else if (action === "remove" && langCode) {
      // Remove the selected language
      updatedLangCodes = updatedLangCodes.filter((code) => code !== langCode);
    }

    const autoTransParam: AV.IAutoTransParam = {
      feed: {
        id: entity != undefined ? (entity?.id ?? "") : "",
        pk: entity != undefined ? (entity?.id ?? "") : "",
        type: "Feed",
      },
      autoTran: updatedLangCodes, // Update selected languages
    };

    try {
      await AV.Feed.setAutoTran(autoTransParam);

      // Fetch updated feed
      const feedParam: AV.IFeedParam = {
        feed: autoTransParam.feed,
        startDate: new Date(0),
        forward: false,
      };

      const feed: AV.IFeed | null = await AV.Feed.getFeed(feedParam);
      setTranslationLang(
        //feed?.autoTrans?.length > 0
        //  ? feed?.autoTrans[0]
        //  : Loc.currentLang.purchaseCredits.selectLanguage
        Loc.currentLang.purchaseCredits.selectLanguage,
      );

      // Map the autoTrans codes to their corresponding names from userLang
      const updatedSelectedLanguages =
        feed?.autoTrans?.map((code: string) => {
          const lang = modifiedUserLang.find(
            (lang: { code: string; name: string }) => lang.code === code,
          );
          return lang
            ? { code: lang.code, name: lang.name }
            : { code, name: code }; // Fallback to code if name not found
        }) || [];

      setSelectedTranslationLang(updatedSelectedLanguages);
      if (updatedSelectedLanguages?.length > 0) {
        setIsSelectedLang(true);
      } else {
        setIsSelectedLang(false);
      }
    } catch (error) {
      console.error(
        `Error ${action === "add" ? "adding" : "removing"} language:`,
        error,
      );
    } finally {
      setIsLoadingAdd(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const loadLanguages = async () => {
      let effectiveEntity = entity;
      if (effectiveEntity === undefined) {
        effectiveEntity = currentUser;
        if (isMounted) setIsEntity(currentUser);
      }

      const feedParam: AV.IFeedParam = {
        feed: {
          id: effectiveEntity?.id ?? "",
          pk: effectiveEntity?.id ?? "",
          type: "Feed",
        },
        startDate: new Date(0),
        forward: false,
      };

      const feed: AV.IFeed | null = await AV.Feed.getFeed(feedParam);

      if (isMounted) {
        setTranslationLang(Loc.currentLang.purchaseCredits.selectLanguage);
      }

      if (!userLang && effectiveEntity?.type == "Person") {
        let val = await AV.AVEntity.langList(effectiveEntity);
        if (val && isMounted) {
          dispatch(setusersLang([val]));
        }
      }

      //if (isMounted && userLang?.length > 0) {
      //  setModifiedUserLang([
      //    {
      //      code: Loc.currentLang.purchaseCredits.selectLanguage,
      //      name: Loc.currentLang.purchaseCredits.selectLanguage,
      //    },
      //    ...userLang,
      //  ]);
      //}

      const selectedLanguages =
        feed?.autoTrans?.map((code: string) => {
          const lang = userLang?.find(
            (lang: { code: string; name: string }) => lang.code === code,
          );
          return lang
            ? { code: lang.code, name: lang.name }
            : { code, name: code };
        }) || [];

      if (isMounted) {
        setIsEntity(effectiveEntity);
        setSelectedTranslationLang(selectedLanguages);
        setIsSelectedLang(selectedLanguages.length > 0);
      }
    };

    loadLanguages();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (userLang?.length > 0) {
      setModifiedUserLang([
        {
          code: Loc.currentLang.purchaseCredits.selectLanguage,
          name: Loc.currentLang.purchaseCredits.selectLanguage,
        },
        ...userLang,
      ]);
    }
  }, [userLang]);

  const buyMoreRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    if (triggerBuyCredits && isMounted) {
      setShowCreditsPopup(true);
      setTimeout(() => {
        if (isMounted) setTriggerBuyCredits?.(false);
      }, 0);
    }

    return () => {
      isMounted = false;
    };
  }, [triggerBuyCredits]);

  useEffect(() => {
    if (entity || currentUser) {
      setCreditsAvailable(
        entity
          ? (entity?.plan?.credits ?? 0)
          : (currentUser?.plan?.credits ?? 0),
      );
    }
  }, [entity, currentUser]);

  return (
    <>
      {pageLoader ? (
        <PageLoader />
      ) : (
        <Box
          bg="white"
          p={6}
          borderRadius="lg"
          shadow="sm"
          width="100%"
          maxWidth="800px"
        >
          <HStack justifyContent="space-between" alignItems="center" mb={4}>
            <Text fontSize="md" fontWeight="medium">
              {/*{Loc.currentLang.menu.preferredLanguage}*/}
            </Text>
            <HStack alignItems="center" space={2}>
              <Text fontSize="sm" color="gray.600">
                {Loc.currentLang.purchaseCredits.Credits}
              </Text>
              <Box
                bg="#FFF7E6"
                px={2}
                py={1}
                borderRadius="full"
                display="flex"
                flexDirection="row"
                alignItems="center"
              >
                <DollarCoinsIcon height="15px" width="15px" />
                <Text fontSize="sm" color="#D46B08">
                  {creditsAvailable}
                </Text>
              </Box>
              <Pressable onPress={() => setShowCreditsPopup(true)}>
                <Text
                  fontSize="sm"
                  color="#00A09B"
                  textDecorationLine="underline"
                >
                  {Loc.currentLang.manageConversation.buyMoreCredits}
                </Text>
              </Pressable>
            </HStack>
          </HStack>

          <HStack space={4} alignItems="center" mb={4}>
            <Box flex={1}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {Loc.currentLang.menu.language}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={translationLang}
                  label="Languages"
                  onChange={(e) => {
                    setTranslationLang(e.target.value);
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                  }}
                >
                  {modifiedUserLang?.map((option) => (
                    <MenuItem
                      key={option.code}
                      value={option.code}
                      disabled={
                        option.code ===
                        Loc.currentLang.purchaseCredits.selectLanguage
                      }
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <HStack
              space={5}
              justifyContent="center"
              alignSelf="center"
              flexWrap="wrap"
              maxWidth="100%"
            >
              <Button
                onPress={() => handleLanguageUpdate("add")}
                backgroundColor="AVColor.primary"
                height="45px"
                px={6}
                rounded="full"
                isLoading={isLoadingAdd}
                isDisabled={
                  translationLang ===
                    Loc.currentLang.purchaseCredits.selectLanguage || // Disable if no language is selected
                  selectedTranslationLang.some(
                    (lang) => lang.code === translationLang, // Disable if the selected language is already in the list
                  )
                }
              >
                <Text fontSize="16px" color="white">
                  {Loc.currentLang.purchaseCredits.add}
                </Text>
              </Button>
            </HStack>
          </HStack>

          <HStack alignItems="center" space={2}>
            <Box>
              <img
                src={inform}
                style={{
                  width: "16px",
                  height: "16px",
                  opacity: 0.6,
                }}
                alt="info"
              />
            </Box>
            <Text fontSize="sm" color="gray.500">
              {
                Loc.currentLang.manageConversation
                  .autoTranslationRequiresCredits
              }
            </Text>
          </HStack>

          {isSelectedLang && (
            <Box mt={4}>
              <Text fontSize="16px" fontWeight="medium" color="gray.600" mb={2}>
                {Loc.currentLang.manageConversation.selectedLanguages}
              </Text>
              <HStack flexWrap="wrap" space={2}>
                {selectedTranslationLang.map((lang) => (
                  <Box
                    key={lang.code}
                    bg="gray.100"
                    px={3}
                    py={1}
                    borderRadius="full"
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                  >
                    <Text fontSize="14px" color="gray.700" mr={2}>
                      {lang.name}
                    </Text>
                    <Pressable
                      onPress={() => handleLanguageUpdate("remove", lang.code)}
                    >
                      <CloseIcon size="12px" color="gray.500" />
                    </Pressable>
                  </Box>
                ))}
              </HStack>
            </Box>
          )}
        </Box>
      )}

      {isAutoTrans && showCreditsPopup && (
        <PurchaseCreditsPopup
          entity={entity}
          setSharedPlan={setSharedPlan}
          showCreditsPopup={showCreditsPopup}
          setShowCreditsPopup={setShowCreditsPopup}
          triggerBuyCredits={triggerBuyCredits}
          setTriggerBuyCredits={setTriggerBuyCredits}
        />
      )}
    </>
  );
}

export default AutoTranslation;
